document.addEventListener('DOMContentLoaded', function () {
    const modal     = document.getElementById('rc-newsletter-modal');
    const overlay   = modal.querySelector('.rc-modal-overlay');
    const closeBtn  = modal.querySelector('.rc-modal-close');

    function openModal() {
        modal.classList.remove('hidden');
    }

    function closeModal() {
        modal.classList.add('hidden');
    }

    // Add trigger logic (example button)
    document.querySelectorAll('[data-newsletter-modal]').forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            openModal();
        });
    });

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);
});